import { Component, OnInit } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';
import { Intervention } from 'src/app/domain/planning/intervention';
import { ClientModel } from 'src/app/domain/Shared/client';
import { EExportType } from 'src/app/domain/Shared/enum/export-type';
import { ClientService } from 'src/app/services/client.service';
import { ExportService } from 'src/app/services/export.service';
import { CoreData } from 'src/app/tools/core-data';
import { StringConverter } from 'src/app/tools/ui/string-converter';

@Component({
    selector: 'app-export',
    templateUrl: './export.component.html',
    styleUrls: ['./export.component.scss']
})
export class ExportComponent implements OnInit {
    public EInterventionType = EInterventionType;
    public EExportType = EExportType;
    private subject: Subject<string> = new Subject();

    public FromDate: Date;
    public ToDate: Date;
    public ClientList: ClientModel[] = [];
    public SelectedClient: ClientModel;
    public SearchText: string;
    public InterventionTypeList: string[] =
        Object.values(EInterventionType)
            .filter(x => !isNaN(Number(x)))
            .map((x: EInterventionType) => StringConverter.getInterventionTypeName(x));

    public INTERVENTION_TYPE_ALL: 'ALL';
    public InterventionType: EInterventionType;

    public InterventionList: Intervention[] = [];

    get CanGenerate() {
        return this.InterventionList && this.InterventionList.filter(x => x.IsSelected).length > 0;
    }

    constructor(
        private coreData: CoreData,
        private clientService: ClientService,
        private exportService: ExportService,
        private dialog: MatDialog) { }

    ngOnInit(): void {
        this.subject.pipe(
            debounceTime(500)
        ).subscribe(() =>
            this.searchClientAndIntervention()
        );
        this.coreData.CurrentPageName = "";
    }

    getColorByInterventionStatus(type: EInterventionType) {
        switch (type) {
            case EInterventionType.IBD:
                return '#F5822B';
            case EInterventionType.IBGN:
                return '#FFDD4A';
            case EInterventionType.MPCE:
                return '#3AB795';
            case EInterventionType.EAU:
                return 'aqua';
            case EInterventionType.LAC:
                return 'cornflowerblue';
            case EInterventionType.MGCE:
                return 'navy';
            case EInterventionType.IBMR:
                return 'olivedrab';
            case EInterventionType.IML:
                return '#bda676';
        }
    }

    displayFn(m: ClientModel | string): string {
        if (m instanceof ClientModel) {
            return `${m.ELIMSData.ClientName} - ${m.ELIMSData.ClientZipCode} - ${m.ELIMSData.ClientCity}`;
        }

        if (typeof (m) === 'string') {
            return m;
        }
    }

    onKeyUp() {
        if (!this.SearchText || this.SearchText.length < 3) {
            this.ClientList = [];
            return;
        }

        this.subject.next();
    }

    setSelectedClient(event: MatAutocompleteSelectedEvent) {
        this.SelectedClient = this.ClientList.find(x => x.ELIMSData.StationCode === event.option.value.ELIMSData.StationCode);
        this.InterventionList = this.SelectedClient.InterventionList;
        this.InterventionList.forEach(x => x.IsSelected = true);
    }

    selectedInterventionType(event: MatSelectChange) {
        if (!this.SearchText || this.SearchText.length < 3) {
            this.ClientList = [];
            return;
        }

        this.searchClientAndIntervention();
    }

    searchClientAndIntervention() {
        this.clientService.getClientAndInterventionByDateAndName(this.SearchText, this.FromDate, this.ToDate, this.InterventionType).subscribe(x => {
            this.ClientList = x;
        });
    }

    // openTextDialog(type: number) {
    //   const dialogRef = this.dialog.open(EditTextBoxDialog, {
    //     width: '666px',
    //     data: { title: 'Code Producteur', text: '' }
    //   });

    //   dialogRef.afterClosed().subscribe((result: string) => {
    //     if (result) {
    //       this.generateExport(type, result);
    //     }
    //   });
    // }

    getALL() {
        this.exportService.getExportALL().subscribe(x => {
            this.promptFile(x);
        });
    }

    promptFile(x: any) {
        var url = window.URL.createObjectURL(x.body);
        var a = document.createElement('a');

        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(x.headers.get('Content-Disposition'));
        if (matches != null && matches[1]) {
            a.download = matches[1].replace(/['"]/g, '');
        }

        a.href = url;
        // a.download = x.fileName;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();  //afterwards we remove the element again 
    }

    generateExport(type: EExportType) {

        switch (type) {
            case EExportType.SaisieMinVCEE:
                this.exportService.generateSaisieMinVCEExport(this.InterventionList.filter(x => x.IsSelected), true).subscribe(x => {
                    this.exportService.fetchExport(x);
                });
                break;
            case EExportType.SaisieMinVCEEGrouped:
                this.exportService.generateSaisieMinVCEExport(this.InterventionList.filter(x => x.IsSelected), false).subscribe(x => {
                    this.exportService.fetchExport(x);
                });
                break;
            case EExportType.SoutienBioMinVCE:
                this.exportService.generateSoutienBioMinVCEExport(this.InterventionList.filter(x => x.IsSelected)).subscribe(x => {
                    this.exportService.fetchExport(x);
                });
                break;
            case EExportType.SoutienBioDiat:
                this.exportService.generateSoutienBioDiatExport(this.InterventionList.filter(x => x.IsSelected)).subscribe(x => {
                    this.exportService.fetchExport(x);
                });
                break;
            case EExportType.OSUR:
                this.exportService.generateOSURExport(this.InterventionList.filter(x => x.IsSelected)).subscribe(x => {
                    this.exportService.fetchExport(x);
                });
                break;
            case EExportType.EchangeListe:
                this.exportService.generateEchangeListeExport(this.InterventionList.filter(x => x.IsSelected)).subscribe(x => {
                    this.exportService.fetchExport(x);
                });
                break;
            case EExportType.EchangeListe:
                this.exportService.generateMphytCE(this.InterventionList.filter(x => x.IsSelected)).subscribe(x => {
                    this.exportService.fetchExport(x);
                });
                break;
            case EExportType.RE:
                this.exportService.generateREZip(this.InterventionList.filter(x => x.IsSelected)).subscribe(x => {
                    this.exportService.fetchExport(x);
                });
                break;
            case EExportType.RI:
                this.exportService.generateRIZip(this.InterventionList.filter(x => x.IsSelected)).subscribe(x => {
                    this.exportService.fetchExport(x);
                });
                break;
            case EExportType.RP:
                this.exportService.generateRPZip(this.InterventionList.filter(x => x.IsSelected)).subscribe(x => {
                    this.exportService.fetchExport(x);
                });
                break;
        }
    }
}
